import { getRegionFromLocale } from '@klarna-web-sdk/utils/src/region';
import { ASSETS_URL } from '../../config';
import createInterstitialToken from '../createInterstitialToken/createInterstitialToken';
import enhanceLinkWithClientInfo from '../enhanceLinkWithClientInfo/enhanceLinkWithClientInfo';
export default function createInterstitialUrl({ locale, environment, bespokeId = 'payment-information-generic-interstitial', clientId, }) {
    const region = getRegionFromLocale(locale);
    const baseUrl = ASSETS_URL[environment][region];
    const token = createInterstitialToken(locale, bespokeId);
    let url = `${baseUrl}/learn-more/index.html?showButtons=true&showBackground=false`;
    url = enhanceLinkWithClientInfo(url, clientId);
    return `${url}#${token}`;
}
